import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface SessionUser {
  id: string
  email: string
  role: string
  display_name: string | null
  avatar: string | null
}

export interface ClientAuthorization {
  clientId: string | null
  permissions: string[]
}

interface SessionState {
  status: 'checking' | 'authenticated' | 'anonymous' | 'forbidden' | 'error'
  user: SessionUser | null
  authorization: ClientAuthorization
  forbiddenReason: 'wrong-client' | 'no-permissions' | null
}

const initialState: SessionState = {
  status: 'checking',
  user: null,
  authorization: { clientId: null, permissions: [] },
  forbiddenReason: null,
}

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    authenticated(state, action: PayloadAction<{ user: SessionUser; authorization: ClientAuthorization }>) {
      state.status = 'authenticated'
      state.user = action.payload.user
      state.authorization = action.payload.authorization
      state.forbiddenReason = null
    },
    anonymous(state) {
      state.status = 'anonymous'
      state.user = null
      state.authorization = { clientId: null, permissions: [] }
      state.forbiddenReason = null
    },
    forbidden(state, action: PayloadAction<{ user: SessionUser; reason: 'wrong-client' | 'no-permissions'; authorization: ClientAuthorization }>) {
      state.status = 'forbidden'
      state.user = action.payload.user
      state.authorization = action.payload.authorization
      state.forbiddenReason = action.payload.reason
    },
    failed(state) {
      state.status = 'error'
      state.user = null
      state.authorization = { clientId: null, permissions: [] }
      state.forbiddenReason = null
    },
  },
})

export const sessionActions = sessionSlice.actions
export const sessionReducer = sessionSlice.reducer
export type { SessionState }
